import React, { useState } from "react";

const DomainModal = ({ translate, onSave, onClose, app }) => {
  const [domainName, setDomainName] = useState("");
  const [port] = useState(app.port); // Initialize with app.port

  const handleSave = (event) => {
    event.preventDefault();
    onSave(domainName, port);
  };

  return (
    <div className="modal" style={{ display: "flex" }}>
      <div className="modal-content">
        <h3>{translate("domain")}</h3>
        <form onSubmit={handleSave}>
          <input
            type="text"
            placeholder={translate("domain")}
            value={domainName}
            onChange={(e) => setDomainName(e.target.value)}
            required
          />
          <button type="submit">{translate("save")}</button>
          <button type="button" onClick={onClose}>
            {translate("cancel")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default DomainModal;